import { useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { clienteApi } from "@/lib/api";
import { toast } from "sonner";
import { Eye, EyeOff, ArrowLeft, CheckCircle2 } from "lucide-react";

export default function RedefinirSenha() {
  const { token } = useParams();
  const nav = useNavigate();
  const [senha, setSenha] = useState("");
  const [confirmar, setConfirmar] = useState("");
  const [mostrar, setMostrar] = useState(false);
  const [enviando, setEnviando] = useState(false);
  const [sucesso, setSucesso] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (senha.length < 6) return toast.error("A senha precisa ter pelo menos 6 caracteres.");
    if (senha !== confirmar) return toast.error("As senhas não coincidem.");
    setEnviando(true);
    try {
      await clienteApi.post("/cliente-auth/redefinir-senha", { token, senha });
      setSucesso(true);
      setTimeout(() => nav("/portal/login", { replace: true }), 1500);
    } catch (e2) {
      toast.error(e2?.response?.data?.detail || "Link inválido ou expirado.");
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div className="min-h-screen bg-zinc-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md bbh-card p-6 sm:p-8" data-testid="redefinir-senha-page">
        {sucesso ? (
          <div className="text-center py-6">
            <div className="w-14 h-14 mx-auto rounded-full bg-emerald-100 flex items-center justify-center mb-4">
              <CheckCircle2 className="w-7 h-7 text-emerald-600" />
            </div>
            <h1 className="font-heading text-2xl font-bold mb-2">Senha atualizada</h1>
            <p className="text-sm text-zinc-600">Redirecionando para o login…</p>
          </div>
        ) : (
          <>
            <Link to="/portal/login" className="inline-flex items-center gap-1 text-xs text-zinc-500 hover:text-zinc-800 mb-4">
              <ArrowLeft className="w-3 h-3" /> Voltar ao login
            </Link>
            <div className="text-[11px] font-semibold uppercase tracking-widest text-zinc-500 mb-1">
              Portal do cliente
            </div>
            <h1 className="font-heading text-2xl sm:text-3xl font-bold tracking-tight mb-1">Redefinir senha</h1>
            <p className="text-sm text-zinc-600 mb-6">Escolha uma nova senha para sua conta.</p>
            <form onSubmit={submit} className="space-y-4" data-testid="redefinir-senha-form">
              <div>
                <label className="text-[10px] font-semibold uppercase tracking-widest text-zinc-500">Nova senha</label>
                <div className="relative mt-1">
                  <input
                    type={mostrar ? "text" : "password"}
                    required
                    minLength={6}
                    value={senha}
                    onChange={(e) => setSenha(e.target.value)}
                    data-testid="redefinir-senha-input"
                    autoComplete="new-password"
                    className="w-full px-3 py-2.5 pr-10 rounded-md border border-zinc-200 bbh-input text-sm"
                    placeholder="Mínimo 6 caracteres"
                  />
                  <button
                    type="button"
                    onClick={() => setMostrar((v) => !v)}
                    className="absolute right-2 top-1/2 -translate-y-1/2 p-1.5 text-zinc-400 hover:text-zinc-700"
                    aria-label="Mostrar/ocultar senha"
                  >
                    {mostrar ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                  </button>
                </div>
              </div>
              <div>
                <label className="text-[10px] font-semibold uppercase tracking-widest text-zinc-500">Confirmar nova senha</label>
                <input
                  type={mostrar ? "text" : "password"}
                  required
                  minLength={6}
                  value={confirmar}
                  onChange={(e) => setConfirmar(e.target.value)}
                  data-testid="redefinir-senha-confirmar"
                  autoComplete="new-password"
                  className="mt-1 w-full px-3 py-2.5 rounded-md border border-zinc-200 bbh-input text-sm"
                />
              </div>
              <button
                type="submit"
                disabled={enviando}
                data-testid="redefinir-senha-submit"
                className="w-full inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-md bbh-btn-primary text-sm font-semibold disabled:opacity-50"
              >
                {enviando ? "Redefinindo…" : "Redefinir senha"}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
